import { Reducer } from "react";

import { AppContextAction, AppContextActionType, AppState } from "./App.types";

export const AppReducer: Reducer<AppState, AppContextAction> = (state, action) => {
  switch (action.type) {
    case AppContextActionType.SET_APP:
      return { ...state, app: action.payload };
    case AppContextActionType.SET_LOADING:
      return { ...state, loading: action.payload };
  }
};
